import React from 'react';
import { useSelector } from 'react-redux';
import { FormControllerProvider } from '../../../../helpers/formManager';
import Body from './presenters/Body';
import Header from './presenters/Header';
import SetupLayout from '../../shared/ui/SetupLayout';
import { selectors, sliceKeys } from '../../model';

const { selectCreateStep } = selectors[sliceKeys.createPage];

const CreatePage = ({ className }) => {
  const step = useSelector(selectCreateStep);

  return (
    <FormControllerProvider>
      <SetupLayout
        className={className}
        header={<Header step={step} />}
        body={<Body step={step} />}
      />
    </FormControllerProvider>
  );
};

export default CreatePage;
